import React, { Fragment, useEffect } from 'react';
import Slider from 'react-slick';

import Breadcrumbs from '../../../CommonComponents/Breadcrumbs/Breadcrumbs';
import { MAIN_TEXT_RUN, MAIN_NAVS } from './constants';

import './HeaderFreaksStore.scss';

export const HeaderFreaksStore = ({ baseImgUrl }) => {
  const title = `OWNDAYS × FREAK'S STORE`;
  const breadcrumbs = [
    { path: '/sg/en', label: 'Homepage' },
    { path: '/sg/en/news', label: 'News' },
    { path: '#', label: title },
  ];

  const textSettings = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: 'linear',
    arrows: false,
    variableWidth: true,
  };

  const scrollToSection = id => {
    if (!id) return;

    const elementId = id.startsWith('#') ? id.substring(1) : id;
    const element = document.getElementById(elementId);

    window.location.hash = elementId;

    if (element) {
      const headerHeight = document.querySelector('header')?.offsetHeight || 0;
      let headerOffset = 0;

      if (window.innerWidth <= 767) {
        headerOffset = headerHeight - 140;
      } else {
        headerOffset = headerHeight - 80;
      }

      const elementTop = element.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: elementTop - headerOffset,
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    if (window.Fancybox) {
      window.Fancybox.bind("[data-fancybox='etc']", {});
    }
  }, []);

  return (
    <Fragment>
      <Breadcrumbs crumbs={breadcrumbs} />

      <section className="header-freaks-store__main-2025">
        <div className="header-freaks-store__main-2025__bg">
          <picture>
            <source media="(min-width: 768px)" srcSet={`${baseImgUrl}/main-banner_pc.webp`} />
            <img
              alt={title}
              src={`${baseImgUrl}/main-banner_sp.webp`}
            />
          </picture>
        </div>

        <h1 className="header-freaks-store__main-2025__logo">
          <picture>
            <source media="(min-width: 768px)" srcSet={`${baseImgUrl}/logo/od_pc.svg`} />
            <img alt={title} loading="lazy" src={`${baseImgUrl}/logo/od_sp.svg`} />
          </picture>
        </h1>

        <div className="header-freaks-store__main-2025__text-run">
          <Slider {...textSettings} className="header-freaks-store__main-2025__text-run__list">
            {Array.from({ length: 10 })
              .flatMap(() => MAIN_TEXT_RUN)
              .map((item, index) => (
                <div key={index}>
                  <li className={item.className}>{item.text}</li>
                </div>
              ))}
          </Slider>
        </div>
      </section>

      <section className="header-freaks-store__navs">
        <div className="base-freaks-store-2025__container">
          <h2 className="header-freaks-store__navs__title">
            Step into the new season <br />
            with style and excitement
          </h2>
          <p className="header-freaks-store__navs__desc">
            Back by popular demand, our 2nd collection is here! <br />
            Featuring sunglasses in stylish design with functional lens options such as Transitions{' '}
            <br />
            and Polarised lenses, this lineup blends functionality with trendiness to suit any
            scene. <br />
            Stay stylish and protect from the sun with 'OWNDAYS × <span>FREAK'S</span> STORE'.
          </p>

          <ul className="header-freaks-store__navs__list">
            {MAIN_NAVS.map((nav, index) => (
              <li
                key={nav.id}
                className="header-freaks-store__navs__item"
                data-aos="fade-up"
                onClick={() => scrollToSection(nav.id)}
              >
                <div className="header-freaks-store__navs__item-header">
                  <p className="header-freaks-store__navs__item-no">
                    No.<strong>0{index + 1}</strong>
                  </p>
                  <img
                    alt={nav.altGlasses}
                    className="header-freaks-store__navs__item-product"
                    loading="lazy"
                    src={`${baseImgUrl}/navs/nav-glasses-${index + 1}.webp`}
                  />
                </div>

                <div className="header-freaks-store__navs__item-thumbnail">
                  <picture>
                    <source
                      media="(min-width:768px)"
                      srcSet={`${baseImgUrl}/navs/nav-${index + 1}_pc.webp`}
                      type="image/webp"
                    />
                    <img
                      alt={nav.alt}
                      loading="lazy"
                      src={`${baseImgUrl}/navs/nav-${index + 1}_sp.webp`}
                    />
                  </picture>
                </div>

                <div className="header-freaks-store__navs__item-body">
                  <h3 className="header-freaks-store__navs__item-title">{nav.title}</h3>
                  <p className="header-freaks-store__navs__item-frame">{nav.frame}</p>
                </div>

                <div className="header-freaks-store__navs__item-footer">
                  <img
                    alt={nav.alt}
                    className="header-freaks-store__navs__item-icon"
                    src={`${baseImgUrl}/arrow-down-black-circle-icon.svg`}
                  />
                  <p className="header-freaks-store__navs__item-price">{nav.price}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </Fragment>
  );
};
